import React from 'react';
import DescriptionList from "components/DescriptionList";
import DescriptionListItem from "components/DescriptionListItem";
import DescriptionTerm from "components/DescriptionTerm";
import DescriptionDetails from "components/DescriptionDetails";
import {formattedDateTime} from "services/date";
import StackedList from "components/StackedList";
import StackedListItem from "components/StackedListItem";
import {toTitleCase} from "services/string";
import Card from "components/Card";
import {User} from "types/User";

// Types ----

type AccountCardProps = {
  audienceMember?: User
  isLoading?: boolean
}

// Component ----

function AccountCard({audienceMember, isLoading}: AccountCardProps) {
  return (
    <Card heading="Account" isLoading={isLoading}>
      <DescriptionList>
        <DescriptionListItem span={1}>
          <DescriptionTerm>Registered</DescriptionTerm>
          <DescriptionDetails>
            {formattedDateTime(audienceMember?.created_at)}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Account Claimed</DescriptionTerm>
          <DescriptionDetails>
            {formattedDateTime(audienceMember?.claimed_at) || 'Never'}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={2}>
          <DescriptionTerm>First Logged-In</DescriptionTerm>
          <DescriptionDetails>
            {formattedDateTime(audienceMember?.first_logged_in_at) || 'Never'}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Last Logged-In</DescriptionTerm>
          <DescriptionDetails>
            {formattedDateTime(audienceMember?.last_logged_in_at) || 'Never'}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Last Logged-In From</DescriptionTerm>
          <DescriptionDetails>
            {audienceMember?.last_login_ip || 'N/A'}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Linked Accounts</DescriptionTerm>
          <DescriptionDetails>
            {!!audienceMember?.linked_account_count &&
              <div className="sm:max-w-sm">
                <StackedList>
                  {audienceMember?.linked_accounts.map(linkedAccount => (
                    <StackedListItem key={linkedAccount.id}>
                      <div className="flex justify-between w-full">
                        <div className="font-semibold">{toTitleCase(linkedAccount.provider)}</div>
                        <div className="text-gray-500">{linkedAccount.username}</div>
                      </div>
                    </StackedListItem>
                  ))}
                </StackedList>
              </div>
            }

            {!audienceMember?.linked_account_count && 'None'}
          </DescriptionDetails>
        </DescriptionListItem>
      </DescriptionList>
    </Card>
  );
}

// Export ----

export default AccountCard;